import angular from "angular";

import { TaxCard2019Logic, Taxcard, TaxcardKind, Taxcards, WorkerCurrentTaxcards } from "@salaxy/core";
import { UiCrudHelpers, UiHelpers } from "../../services";

/**
 * Helps listing current account tax cards (latest and previous ones)
 * and also the employers that are using the latest taxcards.
 */
export class MyTaxcardsController implements angular.IController {

  /**
   * For NG-dependency injection
   * @ignore
   */
  public static $inject = ["Taxcards", "UiCrudHelpers", "UiHelpers"];

  /** The data after it has been loaded. Null if nothing is loaded yet.  */
  public current: WorkerCurrentTaxcards;

  /** The current active tab. */
  public currentTab: string;

  /** Creates a new MyTaxcardsController */
  constructor(
    private taxcards: Taxcards,
    private uiCrudHelpers: UiCrudHelpers,
    private uiHelpers: UiHelpers,
    ) {}

  /** Initializes the controller. */
  public $onInit = () => {
    this.reload();
  };

  /** Reloads the data from the server. */
  public reload() {
    this.current = null;
    this.taxcards.getMyTaxcards().then((result) => {
      this.current = result;
      if (this.current?.active) {
        this.currentTab = "calcs";
      }
    });
  }

  /**
   * Removes a taxcard from the list and does a refresh.
   * @param id Taxcard id.
   */
  public deleteTaxCard(id: string) {
    this.taxcards.delete(id).then(() => {
      this.reload();
    });
  }

  /**
   * Sets the users automatic shared taxcard as ON or if already set refreshes the taxcard from tax authorities.
   */
  public setSharedAutoForSelf(): void {
    if (this.current.active?.card.kind === TaxcardKind.Auto) {
      this.uiCrudHelpers.refreshAutoTaxcard(this.current.active.id).then((_taxcards) => {
        this.reload();
      });
    } else {
      const loader = this.uiHelpers.showLoading("SALAXY.NG1.WorkerDetailsComponent.taxCard.setSharedAutoForSelf.loadingTitle", "SALAXY.NG1.WorkerDetailsComponent.taxCard.setSharedAutoForSelf.loadingText");
      this.taxcards.setAuto(this.current.personalId).then((x) => {
        if (x == null) {
          loader.dismiss();
          this.uiHelpers.showAlert("SALAXY.NG1.WorkerDetailsComponent.taxCard.setSharedAutoForSelf.alertTitle", "SALAXY.NG1.WorkerDetailsComponent.taxCard.setSharedAutoForSelf.alertTextAutoCard");
        } else {
          this.reload();
          loader.dismiss();
        }
      });
    }
  }

  /**
   * Gets the chart type that should be shown.
   */
  public get chartType(): "full" | "pie" | "none" {
    if (!this.current) {
      return "none";
    }
    if (this.current.active.card.incomeLimit) {
      return "full";
    }
    return "pie";
  }

  /**
   * Gets main chart configuration for <salaxy-chart>
   * @param taxcard current taxcard
   */
  public getMainChartConfig(taxcard: Taxcard) {
    return this.uiHelpers.cache(this, "mainChartConfig",
      () => TaxCard2019Logic.getMainChartV2(taxcard),
      () => TaxCard2019Logic.getIncomeLimitInfo(taxcard));
  }

  /**
   * Gets pie chart configuration for <salaxy-chart>
   * @param taxcard current taxcard
   */
  public getPieChartConfig(taxcard: Taxcard) {
    return this.uiHelpers.cache(this, "pieChartConfig",
      () => TaxCard2019Logic.getPieChartDataV2(taxcard),
      () => TaxCard2019Logic.getIncomeLimitInfo(taxcard));
  }
}
